import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  /* eslint-disable prettier/prettier */
  return {
    //  Lists
    getList: (idList) => `${baseURL}/api/list/${encodeURIComponent(idList)}`,
    getEntitiesUsingFilter: (idFilter) =>
      `${baseURL}/api/filter/${encodeURIComponent(idFilter)}/entities`,
    getListOfNlList: (force, pageSize, pageNumber, orderBy, orderDescending) =>
      `${baseURL}/api/lists?${encodeParams({ force, pageSize, pageNumber, orderBy, orderDescending })}`,
    getUserVisibleLists: (idUser) =>
      `${baseURL}/api/user/${encodeURIComponent(idUser)}/lists`,
    getUserColumns: (idList) => `${baseURL}/api/users/list/${idList}/columns`,
    updateUserColumns: (idList) =>
      `${baseURL}/api/users/list/${idList}/columns`,
  }
  /* eslint-enable prettier/prettier */
})(process.env.BELIST_URL)

export const BeListApiGetList = (idList) => {
  const url = endpoints.getList(idList)

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const BeListApiGetListOfNlList = () => {
  const url = endpoints.getListOfNlList()

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beListGetUserVisibleLists = (idUser) => {
  const url = endpoints.getUserVisibleLists(idUser)

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beListGetUserColumns = (idList) => {
  const url = endpoints.getUserColumns(idList)

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}

export const beListUpdateUserColumns = (idList, data) => {
  const url = endpoints.updateUserColumns(idList)

  return apiWrapper({
    method: 'put',
    url: url,
    data: data,
  }).then((res) => res.data)
}
